import request from './request'
const path = 'merchants.api.accountype.'
const path1 = 'merchants.api.product.'
const accountApi = {
  /** 账户类型分页数据*/
  getPageApi(data = {}) {
    data.method = `${path}page`
    return request(data)
  },
  /** 账户类型列表 */
  getList(data = {}) {
    data.method = `${path}list`
    return request(data)
  },
  /** 删除账户类型 */
  delete(data = {}) {
    data.method = `${path}deleteById`
    return request(data)
  },
  /** 根据id获取账户类型 */
  getById(data = {}) {
    data.method = `${path}getById`
    return request(data)
  },
  /** 新增账户类型 */
  insert(data = {}) {
    data.method = `${path}insert`
    return request(data, 'post')
  },
  /** 编辑账户类型 */
  update(data = {}) {
    data.method = `${path}update`
    return request(data, 'post')
  },
  /** 根据产品id查询菜单功能树 */
  findProductById(data = {}) {
    data.method = `${path1}findProductById`
    return request(data)
  },
  saveStaff(data = {}) {
    data.method = 'merchants.api.staff.saveStaff'
    return request(data)
  },
  // 获取账户类型下产品菜单功能树
  accountTypeSearchRequest(data) {
    data.method = 'merchants.api.merchant.accountTypeSearchRequest'
    return request(data)
  }
}

export { accountApi }
